import script from "./AllMeg.vue?vue&type=script&setup=true&lang=js"
export * from "./AllMeg.vue?vue&type=script&setup=true&lang=js"

import "./AllMeg.vue?vue&type=style&index=0&id=318afd46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318afd46"]])

export default __exports__